import React, { useState, useEffect, useRef } from 'react'

import {
  Box,
  Button,
  Paper,
  Tooltip,
  Typography,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'
import useSubscription from 'hooks/useSubscription'

import styles from './styles'
import theme from 'theme'

import helpers from 'helpers'

const useStyles = makeStyles(styles)

const PixStep = () => {
  const { paymentData } = useSubscription()

  localStorage.removeItem('@dponet-pre-registration')

  const classes = useStyles()
  const reference = useRef()
  const snackbar = useSnackbar()
  const [copySuccess, setCopySuccess] = useState(false)

  const [component, setComponent] = useState(reference.current)

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  useEffect(() => {
    if (!component) {
      return setComponent(reference.current)
    }
    //eslint-disable-next-line
  }, [reference])

  const copyToClipboard = () => {
    try {
      window.navigator.clipboard.writeText(reference.current.innerText)
      setCopySuccess(true)
      snackbar.open({
        message: 'QRcode copiado com sucesso!',
        variant: 'success',
      })
    } catch {
      snackbar.open({
        message: 'Ocorreu um erro ao copiar QRcode',
        variant: 'error',
      })
    }
  }

  return (
    <Box display="flex" justifyContent="center" width="100%" mt={2.5} mb={5}>
      <Box component={Paper} variant="elevation" elevation={0} minWidth="70%">
        <Box p={2.5}>
          <Typography variant="h4">
            {paymentData?.buyer?.name}, seu pix foi gerado!
          </Typography>
          <Box mt={2.5}>
            <Typography variant="body1">
              Foi enviado pra os e-mails cadastrados os detalhe do pix
            </Typography>
            <Typography variant="body1">
              Copie os números abaixo e cole no seu aplicativo de pagamento
            </Typography>
          </Box>
          <Box
            my={2.5}
            display={isDesktop ? 'flex' : ''}
            justifyContent="space-between"
            alignItems="center"
          >
            <Tooltip title="Copiar">
              <Paper
                onClick={copyToClipboard}
                className={classes.cardBillet}
                variant="elevation"
                elevation={2}
              >
                <Box p={2.5} className={classes.billetNumberBox}>
                  <Typography ref={reference} variant="h5">
                    {paymentData?.pix?.qrCode}
                  </Typography>
                </Box>
              </Paper>
            </Tooltip>
            <Box mr={8} mt={isDesktop ? 0 : 2.5}>
              <Button variant="contained" onClick={copyToClipboard}>
                {copySuccess ? 'Copiado' : 'Copiar'}
              </Button>
            </Box>
          </Box>
          <Box mt={4}>
            <Typography variant="body1">
              Pague até{' '}
              {helpers.formatters.date(
                paymentData?.expirationDate,
                'DD/MM/YYYY HH:mm',
              )}
            </Typography>
          </Box>
          <Box
            mt={isDesktop ? 2 : 1.5}
            display="flex"
            {...(!isDesktop && {
              flexDirection: 'column',
              alignItems: 'baseline',
            })}
            pb={2}
          >
            <img src={paymentData?.pix?.url} alt="QR Code Pix" width={500} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PixStep
